import { render } from "./HeroiconsOutlineStop.vue?vue&type=template&id=3d1f94e3"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineStop.vue"]])

export default __exports__